import React from 'react';
import { deleteSuperadminProfile, } from '@Api';
import { IAbilities, IAuth, IOrganizationStore, } from '@Store';
import { CrudEnum, IPreviewSuperadminProfile, PermissionEnum, TSuperadminProfileSortableListCol, } from 'atlas-shared';
import { tableColumnDatetimeSorter, tableColumnStringSorter, timeSince, } from '@Utils';
import { TFunction, } from 'i18next';
import { NavigateFunction, } from 'react-router';
import { ColumnsType, } from 'antd/lib/table/interface';
import { listAuditButton, listCloneButton, listDeleteButton, listEditButton, GetColumnSearchLikeProps, GetColumnSearchEqualProps, } from '../components';
import { IWithListProps, } from '@Hocs/with.list';

export const SuperadminProfileListColumns = (t: TFunction, navigate: NavigateFunction, showDeleted: boolean, organizations: IOrganizationStore, abilities: IAbilities, auth: IAuth, buttons: Array<(row: IPreviewSuperadminProfile) => React.ReactElement> = [], filters: IWithListProps<IPreviewSuperadminProfile, TSuperadminProfileSortableListCol>['filters'], sorter: IWithListProps<IPreviewSuperadminProfile, TSuperadminProfileSortableListCol>['sorter']): ColumnsType<IPreviewSuperadminProfile> => {
  return [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      sorter: (a: IPreviewSuperadminProfile, b: IPreviewSuperadminProfile) => a.id - b.id,
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'id')?.order || null,
      filteredValue: filters.id || null,
      ...GetColumnSearchEqualProps(t, 'id', t('ID')),
      className: 'table-cell-id',
    },
    {
      title: t('TITLE'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a: IPreviewSuperadminProfile, b: IPreviewSuperadminProfile) => tableColumnStringSorter(a.title, b.title),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'title')?.order || null,
      filteredValue: filters.title || null,
      ...GetColumnSearchLikeProps(t, 'title', t('TITLE')),
      className: 'table-cell-title',
    },
    {
      title: t('CREATED_AT'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: IPreviewSuperadminProfile['created_at'], superadmin_profile: IPreviewSuperadminProfile) => <div className='date-column'>{created_at ? timeSince(t, new Date(created_at), true) : ''}</div>,
      sorter: (a: IPreviewSuperadminProfile, b: IPreviewSuperadminProfile) => tableColumnDatetimeSorter(a.created_at, b.created_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'created_at')?.order || null,
      className: 'table-cell-created_at',
    },
    showDeleted && { 
      title: t('DELETED'), 
      dataIndex: 'deleted_at',
      key: 'deleted_at',
      className: 'table-cell-deleted_at',
      render: (deleted_at: IPreviewSuperadminProfile['deleted_at']) => deleted_at ? timeSince(t, new Date(deleted_at), true) : '',
      sorter: (a: IPreviewSuperadminProfile, b: IPreviewSuperadminProfile) => tableColumnDatetimeSorter(a.deleted_at, b.deleted_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'deleted_at')?.order || null,
    },
    {
      title: '',
      dataIndex: 'operation',
      key: 'operation',
      render: (_: any, row: IPreviewSuperadminProfile) => (
        <div className={'table-operation-wrp'}>
          {!row.deleted_at && buttons.map(button => button(row))}
          {abilities.can(null, CrudEnum.Insert, PermissionEnum.SuperadminProfile, row) && listCloneButton(t, navigate, 'superadmin_profile', row)}
          {abilities.can(null, CrudEnum.Read, PermissionEnum.Audit, row) && listAuditButton(t, navigate, 'superadmin_profile', row)}
          {!row.deleted_at && abilities.can(null, CrudEnum.Update, PermissionEnum.SuperadminProfile, row) && listEditButton(t, navigate, 'superadmin_profile', row)}
          {!row.deleted_at && abilities.can(null, CrudEnum.Delete, PermissionEnum.SuperadminProfile, row) && listDeleteButton(t, row, deleteSuperadminProfile)}
        </div>
      ),
    },
  ].filter(Boolean) as ColumnsType<IPreviewSuperadminProfile>;

};
